import React from 'react';
import Tooltip from '@src/components/Tooltip';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { IconLabelContainer } from './index.style';

const IconLabel = ({
  icon,
  value,
  tooltip,
  customStyle,
  textVariant = 'body-12-regular',
  textColor,
}) => (
  <Tooltip
    title={tooltip}
    placement="top"
    arrow
    disableInteractive
    disableHoverListener={!tooltip}
    borderRadius="8px"
  >
    <IconLabelContainer customStyle={customStyle}>
      {icon}
      <Typography variant={textVariant} color={textColor || COLOR.label2[64]}>
        {value}
      </Typography>
    </IconLabelContainer>
  </Tooltip>
);

export default IconLabel;
